module.exports = __webpack_public_path__ + "img/16.8fc109b1.jpg";